module.exports = __webpack_public_path__ + "img/send-icon.1a2c2da8.svg";